import { api } from '../../../api/index';
import { actions } from '../../../../store/actions/index';

export const getCustomersList = ({ ...data }) => async dispatch => {
  try {
    const response = await api.getCustomersList(data);
    dispatch(actions.setCustomers.act(response.data));
    dispatch(actions.needToUpdateData.act(false));
  } catch (e) {
    return e;
  }
};
